import { useUserStore } from 'shared/state/user';
import { ReloadPage } from 'shared/components/reload-page';
import { Props } from 'shared/@types';
import { DefaultProps } from '@web/library/with-server-props';

export function AuthGuard({ defaultProps, children }: Props<DefaultProps>) {
  const user = useUserStore((state) => state.user);

  if (defaultProps.requiresAuth && !user) {
    return <ReloadPage />;
  }

  return <>{children}</>;
}
